
  import { slugify } from '@/utils/url'
  export default {
    name: 'LinkCardList',
    props: {
      slice: {
        type: Object,
        required: true,
        default() {
          return {}
        },
      },
    },
    computed: {
      formattedCards() {
        return this.slice.items.map((item) => {
          const title = this.$prismic.asText(item.title)
          return {
            title: title,
            image: item.image.url,
            alt: item.image.alt,
            width: item.image.dimensions.width,
            height: item.image.dimensions.height,
            link:
              item.link && item.link.url
                ? item.link.url
                : this.getCardLink(title),
          }
        })
      },
    },
    methods: {
      getCardLink(text) {
        const slug = slugify(text)
        const path = this.$route.path.replace(/\/$/, '')
        return `${path}/${slug}`
      },
    },
  }
